/**
 * Created by aaron on 2017/12/19.
 */

import axios from "axios";
import store from "store";
import Modal from "antd/lib/modal";
import history from "./history";
import pubsub from "pubsub-js";
import apis from "./apis";
import util from "./util";
import apiMap from "./api-map";

const baseURLs = {
    development: "https://shanghu-backend-dev.wetax.com.cn",
    testing: "https://shanghu-backend-test.wetax.com.cn",
    preview: "https://shanghu-backend-pre.wetax.com.cn",
    production: "https://shanghu-backend.wetax.com.cn"
};

// 新版后台域名
const newURLs = {
    development: "https://shanghu-backend-dev.wetax.com.cn",
    production: "https://shanghu-backend.wetax.com.cn"
};

// 无会员权限错误码
const AuthCode = '405'
// 缓存当前未完成的请求数量，便于后面用来关闭loading
let requestCount = 0

function request(opt) {
    opt = Object.assign(
        {
            method: "GET",
            withCredentials: true,
            // timeout: 15000,

            token: false,
            //基本url
            // baseURL: getBaseURLByENV(),

            //token键名
            tokenKey: "token",

            //token失效的code码
            invalidCodes: ["401"],

            //成功状态码
            successCodes: ["0"],

            //是否携带需要token
            needToken: true,

            //请求开始
            onLoadStart: () => {
                //console.log('load-start');
                pubsub.publish("load-start");
            },

            //请求结束
            onLoadEnd: () => {
                //console.log('load-end');
                pubsub.publish("load-end");
            },

            //会话方式
            onMessage: msg =>
                Modal.error({
                    title: "提示",
                    content: msg,
                    okText: "确定"
                }),
            //自定义状态码
            ext: {
                codes: [],
                handle: res => {}
            },

            //自定义意料之外的状态码的处理
            unforeseen: res => {
                //其他无法处理的状态码
                if (res.message === 'Network Error') {
                    res.message = '网络错误'
                }
                // if (res.message === 'timeout of 10000ms exceeded') {
                //     res.message = '请求超时'
                // }
                opt.onMessage(res.message || JSON.stringify(res));
            },

            responseType: "text"

            // headers: {
            //     'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            // },

            // // //解析data成formData
            // transformRequest: [data => qs.stringify(data)],
        },
        opt
    );

    // 由于IE9只支持XDomainRequest方式跨域，且它有许多的限制，如：不能加入自定义header，只支持text/plain格式报文等
    // 所以这里通过代理的方式处理跨域请求
    const ie = util.IEVersion();
    if (ie > 0 && ie < 10) {
        opt.baseURL = "/api";
    }

    if (opt.method.toUpperCase() === "GET") {
        opt.params = Object.assign({}, opt.data);
        delete opt.data;
    }

    if (opt.method.toUpperCase() === "POST") {
        opt.data = Object.assign({}, opt.data);
    }

    //从本地store获取当前环境
    //opt.baseURL = opt.baseURLType[getBaseURLByENV(opt.baseURLType)];

    function sendBefore() {
        requestCount += 1;
        // console.log('load-start');
        opt.onLoadStart();
    }

    function complete() {
        requestCount -= 1;

        if (requestCount <= 0) {
            requestCount = 0;
            // console.log('load-end');
            opt.onLoadEnd();
        }
    }

    sendBefore();

    opt = urlHandler(opt)

    return new Promise((resolve, reject) => {
        /**
         * 自动添加token后请求
         * @param token token
         * @param retry 是否需要重试
         */
        function handle(token = "", retry = false) {
            if (!opt.params) opt.params = {};
            if (opt.needToken) {
                if (opt.token) {
                    opt.params[opt.tokenKey] = opt.token;
                } else {
                    opt.params[opt.tokenKey] = token;
                }
            }

            axios(opt)
                .then(res => {
                    // console.log('respone', JSON.stringify(res.data))
                    complete();

                    const data = res.data;
                    if (opt.ext.codes && opt.ext.codes.indexOf(String(data.code)) >= 0) {
                        //如果匹配到自定义的状态码，将执行自定义的handle
                        opt.ext.handle(data);
                    }
                    else if (opt.successCodes.indexOf(String(data.code)) >= 0) {
                        resolve(data.data);
                    }
                    else if (opt.needToken && opt.invalidCodes.indexOf(String(data.code)) >= 0 && retry) {
                        //再次获取token
                        //前往登录界面重新登录
                        history.push("/user/login");
                    }
                    else if (AuthCode === String(data.code)) {
                        // 无会员权限跳转至会员购买页
                        Modal.error({
                            title: '提示',
                            content: data.message,
                            okText: '确定',
                            onOk() {
                                history.push("/vip-service/version-upgrade")
                            }
                        })
                    }
                    else {
                        // opt.unforeseen(data);
                        // 2018.12.24 修改，这里直接抛错，在catch中统一处理，以便在外边可以用catch或unforeseen处理
                        throw data;
                    }
                })
                .catch(error => {
                    complete();
                    opt.unforeseen(error);
                    return reject(error);
                });
        }

        handle(store.get(opt.tokenKey) || "unknow", true);
    });
}

/**
 * 根据用户版本匹配对应接口域名、地址，新版用户使用新版域名、接口
 * @param opt
 * @return {*}
 */
function urlHandler(opt) {
    const isNew = store.get('new-version')
    if (isNew && isNew === 'true') {
        if (apiMap[opt.url]) {
            console.log(apiMap[opt.url]);
            opt.baseURL = newURLs[process.env.NODE_ENV] || newURLs['production']
            opt.url = apiMap[opt.url]
            return opt
        }
    }
    opt.baseURL = opt.baseURL || (baseURLs[process.env.NODE_ENV] || baseURLs['production'])
    return opt
}

/**
 * 获得环境变量，优先从store获取设置，其次从NODE_ENV获取设置。
 * @returns {*}
 */
function getBaseURLByENV() {
    return baseURLs[process.env.NODE_ENV] || baseURLs['production'];
}

export { apis, request, baseURLs, getBaseURLByENV };
